import {get, ref, serverTimestamp, set} from "firebase/database";
import {database} from "../utils/firebase";
import {ADMIN_CONFIG_PATHS} from "../config/adminConfig";

const WIT_CONFIG_PATH = ADMIN_CONFIG_PATHS.witConfig;

export const defaultWitConfig = {
  enabled: true,
  thresholds: {
    like: 0.98,
    repost: 0.99,
    follower: 0.99,
    connector: 0.99,
    accepter: 0.99,
    subscriber: 0.99,
  },
  intents: ["it_sector", "business_owner", "none"],
  entities: [],
};

const witConfigService = {
  async loadWitConfig() {
    const snapshot = await get(ref(database, WIT_CONFIG_PATH));
    if (snapshot.exists()) {
      return snapshot.val();
    }
    return defaultWitConfig;
  },

  async saveWitConfig(uid, config) {
    const payload = {
      ...config,
      updatedAt: serverTimestamp(),
      updatedBy: uid,
    };
    await set(ref(database, WIT_CONFIG_PATH), payload);
    return payload;
  },
};

export default witConfigService;
